import React, { useState, useEffect, useCallback } from "react";
import Loading from "../components/loading";
import { MainBg2 } from "../components/Mainbg";
import {
  DataLayer,
  filterSurveyItemsByCategory,
  useGoToPage,
} from "../function/functions";
import secureLocalStorage from "react-secure-storage";
import { getAxiosWithOutToken } from "../axios/axiosObj";
import { useSelector } from "react-redux";
import Progress from "../components/Progress";
import { ContinueButton } from "../components/utilities";
import Title1Module from "./module/Title1Module";
import { LoginSocialApple, LoginSocialGoogle } from "reactjs-social-login";
import {
  AppleLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
import { GOOGLE_CLIENT_ID } from "../config/ApisCollection";
import GoogleDataLayerData from "../datadictionary/DataLayerDictionary";
import Popup from "reactjs-popup";
// import { User } from "./User"; // component display user (see detail on /example directory)

// const apple_response = {
//   authorization: {
//     code: "c772988a82cb14cd5878f6ab698757dfe.0.pxww.RKAfJMdGVVODNUCpPquWOw",
//     id_token:
//       "eyJraWQiOiJkTWxFUkJhRmRLIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLmZhc3RiZXR0ZXIuZ2xiIiwiZXhwIjoxNzQ0MDk3ODg1LCJpYXQiOjE3NDQwMTE0ODUsInN1YiI6IjAwMDc2Ni5iMzk5NjgyYWY5OWQ0MjZjYjg5NDNiN2JkZGZkMTVkZi4wNzA1IiwiY19oYXNoIjoiTW1Gb3VYaHVzRktvREtyVGhGUEt1USIsImVtYWlsIjoiYmN0ZzZwZHBkNEBwcml2YXRlcmVsYXkuYXBwbGVpZC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNfcHJpdmF0ZV9lbWFpbCI6dHJ1ZSwiYXV0aF90aW1lIjoxNzQ0MDExNDg1LCJub25jZV9zdXBwb3J0ZWQiOnRydWV9.Zj3Dg8MzGZ34tHAQ71iWxar-LwjngvfHC8f5KAjs4wmGHCoDMeYaUdXeWmfar9BFclwi5ShD1VVEDF6iu4_zrCrEe0T4W001idQZ22XIOg_o5t7TU9DXIDXhqF9U6k5x6lIh60tZLZzFh2wWlIeyklm4OWBARRB_kWa4NHUAkkpS_P956X2vrlDoNAuODKDPQPD0DErX-wYU6uTEVzCfQam4gRCrv-TSgVdVUkZ18r1ooNgD2nPXIHtEvQzjlMbzpDFpfVRi3LTTrEztsoCSZQ9TvIqcxQ_gg83OmzpzuFjL808aSHSa7sfaRuMqXDH46S99tCOFZvmLUUeY7oRiEw",
//     state: "origin:web",
//   },
// };

const isPrivateEmail = (email) => {
  const privateDomains = ["privaterelay.appleid.com"];

  const domain = email.split("@")[1];
  return privateDomains.includes(domain);
};

const Page = () => {
  const { surveyItems } = useSelector((state) => state.webUtilities);
  const REDIRECT_URI = window.location.href;

  const [isLoading] = useState(false);
  const goto = useGoToPage();
  const [userEmail, setUserEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const [Dataloading, setDataLoading] = useState(false);
  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState(null);
  const [socialBtnStatus, setSocialBtnStatuts] = useState(true);
  const [communcateEmailPopup, setCommunicateEmailPopup] = useState([false]);

  const [social_Cred, setSocialCred] = useState({
    google: {
      client_id: GOOGLE_CLIENT_ID,
    },
  });

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  //Data layer code
  useEffect(() => {
    const fastingData = GoogleDataLayerData.find(
      (item) => item.name === "email"
    );

    const dataLayer_res = DataLayer({
      event: fastingData?.eventTitle,
      stage: fastingData?.stageTitle,
    });
  }, []);

  // Google respones handler
  const handleSocialResponse = async (provider, data) => {
    setProvider(provider);

    if (data && data.email) {
      setProfile(data);
      secureLocalStorage.setItem("userEmail", data.email);
      setUserEmail(data.email);
      setContinueBtn(true);
      setTimeout(() => {
        hanldeData(provider, data);
      }, 2000);
    }
    // console.log(data);
  };

  const handleAppleResponse = async (provider, data) => {
    setProvider(provider);

    if (data && data?.authorization?.id_token) {
      try {
        // Split the JWT into header, payload, and signature
        const base64Url = data?.authorization?.id_token?.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );

        // Parse JSON payload
        let decoded = JSON.parse(jsonPayload);
        const email = decoded.email;
        decoded.id_token = data?.authorization?.id_token;

        if (email) {
          if (isPrivateEmail(email)) {
            setCommunicateEmailPopup([true, "apple", decoded]);
          } else {
            setProfile(decoded);
            secureLocalStorage.setItem("userEmail", email);
            setUserEmail(email);
            setContinueBtn(true);
            setTimeout(() => {
              hanldeData(provider, decoded);
            }, 2000);
          }
        } else {
          console.error("Email not found in ID token.");
        }
      } catch (error) {
        console.error("Error decoding ID token:", error);
      }
    }
  };

  const onLoginStart = useCallback(() => {
    setSocialBtnStatuts(false);
  }, []);

  const onLogoutSuccess = useCallback(() => {
    setProfile(null);
    setProvider("");
    alert("logout success");
  }, []);

  useEffect(() => {
    if (secureLocalStorage.getItem("userEmail")) {
      setUserEmail(secureLocalStorage.getItem("userEmail"));
      setContinueBtn(true);
    }
    // console.log(profile);
    if (profile != null) {
      // console.log(profile);

      secureLocalStorage.setItem("userEmail", profile.email);
      setUserEmail(profile.email);
      hanldeData(null, null);
    }
  }, []);
  const [filteredItems, setFilteredItems] = useState(null);

  useEffect(() => {
    if (surveyItems && surveyItems.length !== 0) {
      const filtered = filterSurveyItemsByCategory(surveyItems, "email");
      setFilteredItems(filtered[0]);
    }
  }, [surveyItems]);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;

    if (validateEmail(enteredEmail)) {
      setErrorMsg("");
      setContinueBtn(true);
      secureLocalStorage.setItem("userEmail", enteredEmail);
    } else {
      setErrorMsg("Please enter a valid email address.");
    }
    setUserEmail(enteredEmail);
  };

  if (isLoading) return <Loading />;

  const hanldeData = async (provider, provider_data) => {
    setContinueBtn("Processing...");

    if (provider != null && provider_data != null) {
      setContinueBtn(true);
    } else if (!continueBtn) {
      setErrorMsg("Please enter your valid email address.");

      return false;
    }

    // if (!continueBtn) {
    //   setErrorMsg("Please enter your valid email address.");
    //   return false;
    // }

    setDataLoading(true);
    // setContinueBtn(false)
    let data = {};
    let surveyItems2 = [];
    const country = secureLocalStorage.getItem("country") || "us";
    if (country) {
      data.country = country;
    }
    if (secureLocalStorage.getItem("username")) {
      data.name = secureLocalStorage.getItem("username");
    }
    data.ip = "2001:0db8:3c4d:0015:0000:0000:1a2f:1a2b";
    data.location = "";
    data.device = "web";
    data.time_zone = timeZone;
    data.deviceVer = "3.4";
    data.deviceToken = "123456";

    // Social data
    if (provider === "google" && provider_data) {
      data.email = provider_data.email;
      data.isSocial = "google"; //provider
      data.socialres = {
        access_token: provider_data.access_token,
        scope: provider_data.scope,
        sub: provider_data.sub,
        name: provider_data.name,
        given_name: provider_data.given_name,
        email: provider_data.email,
      };
    } else if (provider === "apple" && provider_data) {
      data.email = userEmail || provider_data?.email;
      data.isSocial = provider; //provider
      data.socialres = {
        access_token: provider_data?.id_token,
        scope: "name email",
        sub: provider_data?.sub,
        name: secureLocalStorage.getItem("username") || "",
        email: userEmail || provider_data?.email,
        given_name: secureLocalStorage.getItem("username") || "",
      };
    } else {
      data.email = userEmail || secureLocalStorage.getItem("userEmail");
      data.isSocial = "";
      data.socialres = {};
    }

    // Other data
    // console.log(data);
    // return false;

    const goalItem = secureLocalStorage.getItem("goalItem");
    if (goalItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "whats_your_goal"
      )[0];

      const newItemObjPromises = filtered.categoryItems.map(async (item) => {
        if (goalItem.includes(item.name)) {
          return {
            itemId: item.itemId,
            isTrue: 1,
            isVal: item.isVal,
          };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });

      Promise.all(newItemObjPromises).then((newItemObjs) => {
        itemCategory.category = "whats_your_goal";
        itemCategory.categoryItems = newItemObjs;
        surveyItems2.push(itemCategory);
      });
    }
    const fastingItem = secureLocalStorage.getItem("fastingItem");
    if (fastingItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "have_you_heard_about_intermittent_fasting"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === fastingItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "have_you_heard_about_intermittent_fasting";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const activityItem = secureLocalStorage.getItem("activityItem");
    if (activityItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "whats_your_activity_level"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === activityItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "whats_your_activity_level";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const nutritionItem = secureLocalStorage.getItem("nutritionItem");
    if (nutritionItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "lets_talk_nutrition"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === nutritionItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "lets_talk_nutrition";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const mealItem = secureLocalStorage.getItem("mealItem");
    if (mealItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "how_many_meals_do_you_eat_per_day"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === mealItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "how_many_meals_do_you_eat_per_day";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const dietaryItem = secureLocalStorage.getItem("dietaryItem");
    if (dietaryItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "are_you_following_specific_diet"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (dietaryItem.includes(item.name)) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "are_you_following_specific_diet";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const allergyItem = secureLocalStorage.getItem("allergyItem");
    if (allergyItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "ingredient_allergies"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (allergyItem.includes(item.name)) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "ingredient_allergies";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
      // console.log(itemCategory);
    }

    const waterItem = secureLocalStorage.getItem("waterItem");
    if (waterItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "what_is_your_daily_water_intake"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === waterItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "what_is_your_daily_water_intake";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const nightItem = secureLocalStorage.getItem("nightItem");
    if (nightItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "be_honest_whats_your_average_night_like"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === nightItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "be_honest_whats_your_average_night_like";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const gender = secureLocalStorage.getItem("gender");
    if (gender) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(surveyItems, "gender")[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === gender) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "gender";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const age = secureLocalStorage.getItem("age");
    if (age) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(surveyItems, "age")[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === `age`) {
          return { itemId: item.itemId, isTrue: 1, isVal: age };
        } else if (item.name === `year`) {
          return { itemId: item.itemId, isTrue: 1, isVal: null };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "age";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }

    const height = secureLocalStorage.getItem("height");
    if (height) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(surveyItems, "height")[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === "feet" && height.ft) {
          return { itemId: item.itemId, isTrue: 1, isVal: height.ft };
        } else if (item.name === "inch" && height.ft && height.inch >= 0) {
          return { itemId: item.itemId, isTrue: 1, isVal: height.inch };
        } else if (item.name === "cm" && height.cm) {
          return { itemId: item.itemId, isTrue: 1, isVal: height.cm };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });

      itemCategory.category = "height";
      itemCategory.categoryItems = newItemObj;
      surveyItems2.push(itemCategory);
    }
    const weight = secureLocalStorage.getItem("weight");
    const weightGoal = secureLocalStorage.getItem("weightGoal");
    if (weight && weightGoal) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(surveyItems, "weight")[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === "weight" && (weight.kg || weight.lbs)) {
          return {
            itemId: item.itemId,
            isTrue: 1,
            isVal: weight.kg || weight.lbs,
          };
        } else if (
          item.name === "target weight" &&
          (weightGoal.kg || weightGoal.lbs)
        ) {
          return {
            itemId: item.itemId,
            isTrue: 1,
            isVal: weightGoal.kg || weightGoal.lbs,
          };
        } else if ((item.name === "lbs" || item.name === "lb") && weight.lbs) {
          return { itemId: item.itemId, isTrue: 1, isVal: null };
        } else if ((item.name === "kgs" || item.name === "kg") && weight.kg) {
          return { itemId: item.itemId, isTrue: 1, isVal: null };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });

      itemCategory.category = "weight";
      itemCategory.categoryItems = newItemObj;
      surveyItems2.push(itemCategory);
    }

    const motivationItem = secureLocalStorage.getItem("motivationItem");
    if (motivationItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "motivation_to_loose_weight"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === motivationItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "motivation_to_loose_weight";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }

    const eventDate = secureLocalStorage.getItem("eventDate");
    if (eventDate) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "sport_event_date"
      )[0];

      const newItemObj = filtered.categoryItems.map((item) => {
        let formattedDate = "";
        if (eventDate !== "null" && eventDate !== null && eventDate !== "") {
          const date = new Date(eventDate);
          formattedDate = date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          });
        }
        return {
          itemId: item.itemId,
          isTrue:
            eventDate !== "null" && eventDate !== null && eventDate !== ""
              ? 1
              : item.isTrue,
          isVal: null,
        };
      });

      itemCategory.category = "sport_event_date";
      itemCategory.categoryItems = newItemObj;
      surveyItems2.push(itemCategory);
    }
    const habit = secureLocalStorage.getItem("habit");
    if (habit) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "motivation_to_loose_weight_male"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === habit && gender.toLowerCase() == "male") {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "motivation_to_loose_weight_male";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    if (habit) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "motivation_to_loose_weight_female"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === habit && gender.toLowerCase() == "female") {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "motivation_to_loose_weight_female";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    if (habit) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "motivation_to_loose_weight_people"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (
          item.name === habit &&
          gender.toLowerCase() !== "female" &&
          gender.toLowerCase() !== "male"
        ) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "motivation_to_loose_weight_people";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const bodyType = secureLocalStorage.getItem("bodyType");
    if (bodyType) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "what_is_your_body_shape_male"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === bodyType && gender.toLowerCase() == "male") {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "what_is_your_body_shape_male";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    if (bodyType) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "what_is_your_body_shape_female"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === bodyType && gender.toLowerCase() == "female") {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "what_is_your_body_shape_female";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    if (bodyType) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "what_is_your_body_shape_people"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (
          item.name === bodyType &&
          gender.toLowerCase() !== "female" &&
          gender.toLowerCase() !== "male"
        ) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "what_is_your_body_shape_people";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const habitItem = secureLocalStorage.getItem("habitItem");
    if (habitItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_habits"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === habitItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_habits";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const emotionItem = secureLocalStorage.getItem("emotionItem");
    if (emotionItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_deal_with_emotions"
      )[0];
      const newItemObj = filtered.categoryItems.map((item, index) => {
        if (index + 1 === emotionItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_deal_with_emotions";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const afterWeekItem = secureLocalStorage.getItem("afterWeekItem");
    if (afterWeekItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_deal_with_afterweek"
      )[0];
      const newItemObj = filtered.categoryItems.map((item, index) => {
        if (index + 1 === afterWeekItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_deal_with_afterweek";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const peopleRoundItem = secureLocalStorage.getItem("peopleRoundItem");
    if (peopleRoundItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_deal_with_peopleround"
      )[0];
      const newItemObj = filtered.categoryItems.map((item, index) => {
        if (index + 1 === peopleRoundItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_deal_with_peopleround";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const multiTaskingItem = secureLocalStorage.getItem("multiTaskingItem");
    if (multiTaskingItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_deal_with_multasking"
      )[0];
      const newItemObj = filtered.categoryItems.map((item, index) => {
        if (index + 1 === multiTaskingItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_deal_with_multasking";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const myPlateItem = secureLocalStorage.getItem("myPlateItem");
    if (myPlateItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "eating_deal_with_myplate"
      )[0];
      const newItemObj = filtered.categoryItems.map((item, index) => {
        if (index + 1 === myPlateItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "eating_deal_with_myplate";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const journeyItem = secureLocalStorage.getItem("journeyItem");
    if (journeyItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "fastbetter_journey_feeling"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === journeyItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "fastbetter_journey_feeling";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const ilikeItem = secureLocalStorage.getItem("ilikeItem");
    if (ilikeItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "with_fastbetter_i_did_like_to"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === ilikeItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "with_fastbetter_i_did_like_to";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const mySelfItem = secureLocalStorage.getItem("mySelfItem");
    if (mySelfItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "i_see_myself"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === mySelfItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "i_see_myself";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const prioritiesItem = secureLocalStorage.getItem("prioritiesItem");
    if (prioritiesItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "your_current_priorities"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === prioritiesItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "your_current_priorities";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const gainweightItem = secureLocalStorage.getItem("gainweightItem");
    if (gainweightItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "have_gained_weight_due_to_life_events"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === gainweightItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "have_gained_weight_due_to_life_events";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const diagnosedItem = secureLocalStorage.getItem("diagnosedItem");
    if (diagnosedItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "have_you_diagnosed_health_condition"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === diagnosedItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category = "have_you_diagnosed_health_condition";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }
    const holisticItem = secureLocalStorage.getItem("holisticItem");
    if (holisticItem) {
      const itemCategory = {};
      const filtered = filterSurveyItemsByCategory(
        surveyItems,
        "holistic_approach_goes_beyond_weight_loss_mood_health"
      )[0];
      const newItemObj = filtered.categoryItems.map((item) => {
        if (item.name === holisticItem) {
          return { itemId: item.itemId, isTrue: 1, isVal: item.isVal };
        } else {
          return {
            itemId: item.itemId,
            isTrue: item.isTrue,
            isVal: item.isVal,
          };
        }
      });
      itemCategory.category =
        "holistic_approach_goes_beyond_weight_loss_mood_health";
      itemCategory.categoryItems = await newItemObj;
      surveyItems2.push(itemCategory);
    }

    data.surveyItems = await surveyItems2;
    // console.log(data.surveyItems)
    // return false
    try {
      const response = await getAxiosWithOutToken({
        method: "POST",
        url: "/pre/preregister",
        data: data,
      });

      if (response && response.data) {
        setContinueBtn(true);
        if (response && response.data && response.data.responce) {
          goto("finalData", response.data.responce, "priceplan");
        }
      } else {
        setContinueBtn(true);
        setErrorMsg(response.data.error.message);
      }
    } catch (error) {
      setContinueBtn(true);
      if (
        error?.response?.data?.error?.message ===
        "Cannot read property 'environment' of null"
      ) {
        setErrorMsg(
          "This email ID is blocked due to improper data saved earlier. Please use a different email."
        );
      } else {
        setErrorMsg(error?.response?.data?.error?.message);
      }
    }
    setDataLoading(false);
    setContinueBtn(true);
    setSocialBtnStatuts(true);
  };

  return (
    <div className="relative ">
      <MainBg2 body_position={""}>
        <Progress progress={100} />
        <div className="w-full sm:mt-28 mt-20 mb-14 email-mob">
          {socialBtnStatus ? (
            <>
              <Title1Module titledata={filteredItems} />
              <p className="tex text-sm">We’ll send you an email ...</p>
              <div className="flex justify-center">
                <div className="w-4/6 ">
                  <input
                    type="email"
                    name="email"
                    value={userEmail || ""}
                    onChange={handleEmailChange}
                    placeholder="your@email.com"
                    className="inputbox mt-5 sm:text-base sm:px-4 sm:py-4 py-3 px-4 text-sm rounded-xl"
                  />
                  {/* cardl22l */}
                </div>
              </div>
              <p className="text-sm text-red-500 text-center">{errorMsg}</p>
              {continueBtn == "Processing..." ? (
                <ContinueButton
                  isdisabled={continueBtn ? "disabled" : ""}
                  label={continueBtn}
                />
              ) : (
                <ContinueButton
                  isdisabled={continueBtn ? "disabled" : ""}
                  label={"Next"}
                  className={""}
                  onClick={() => {
                    hanldeData(null, null);
                  }}
                />
              )}

              <div className="flex  justify-center">
                <div className=" mt-6 w-1/2 px-3 justify-self-center">
                  <p className="text-center">or</p>
                  <LoginSocialGoogle
                    isOnlyGetToken={false}
                    client_id={social_Cred.google.client_id || ""}
                    onLoginStart={onLoginStart}
                    scope="profile email"
                    onResolve={({ provider, data }) => {
                      handleSocialResponse(provider, data);
                    }}
                    onReject={(err) => {
                      setSocialBtnStatuts(true);
                    }}
                  >
                    <GoogleLoginButton
                      style={{
                        fontSize: "14px", // Slightly increased font size
                        backgroundColor: "#fffcfb", // Corrected typo
                        background: "#fffcfb", // Corrected typo
                        border: "1px solid #efeded82", // Google's blue color border
                        color: "#000", // Google's blue color text
                        padding: "10px 15px", // Proper padding for the button
                        borderRadius: "5px", // Slight border radius for smooth edges
                        display: "flex", // Flexbox for centering
                        justifyContent: "center", // Center the text horizontally
                        alignItems: "center", // Center the text vertically
                        boxShadow: "none", // Removed box shadow
                      }}
                      text="Sign up with Google"
                      className="justify-items-center font-bold"
                    />
                  </LoginSocialGoogle>

                  <LoginSocialApple
                    client_id={"com.fastbetter.glb" || ""}
                    scope={"name email"}
                    redirect_uri={REDIRECT_URI}
                    onLoginStart={onLoginStart}
                    onResolve={({ provider, data }) => {
                      console.log(provider);
                      console.log(data);
                      handleAppleResponse("apple", data);
                    }}
                    onReject={(err) => {
                      console.log(err);
                      setSocialBtnStatuts(true);
                    }}
                  >
                    <AppleLoginButton
                      style={{
                        fontSize: "14px", // Slightly increased font size
                        backgroundColor: "#fffcfb", // Corrected typo
                        background: "#fffcfb", // Corrected typo
                        border: "1px solid #efeded82", // Google's blue color border
                        color: "#000", // Google's blue color text
                        padding: "10px 15px", // Proper padding for the button
                        borderRadius: "5px", // Slight border radius for smooth edges
                        display: "flex", // Flexbox for centering
                        justifyContent: "center", // Center the text horizontally
                        alignItems: "center", // Center the text vertically
                        boxShadow: "none", // Removed box shadow
                      }}
                    />
                  </LoginSocialApple>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="m-h-[100vh] content-center ">
                <div className="text-center mb-3">
                  {/* <h1 className="title font-semibold text-3xl">Please wait...</h1> */}
                  <p className="font-normal text-sm">Please wait...</p>
                </div>
              </div>
            </>
          )}
          <AppleCommunicateEmail
            communcateEmailPopup={communcateEmailPopup}
            setCommunicateEmailPopup={setCommunicateEmailPopup}
            userEmail={userEmail}
            setUserEmail={setUserEmail}
            continueBtn={continueBtn}
            hanldeData={hanldeData}
            setProfile={setProfile}
            validateEmail={validateEmail}
            setErrorMsg={setErrorMsg}
            errorMsg={errorMsg}
            setContinueBtn={setContinueBtn}
          />
        </div>
      </MainBg2>
    </div>
  );
};
export default Page;

const AppleCommunicateEmail = ({
  communcateEmailPopup,
  setCommunicateEmailPopup,
  userEmail,
  setUserEmail,
  continueBtn,
  hanldeData,
  setContinueBtn,
  setProfile,
  validateEmail,
  setErrorMsg,
  errorMsg,
}) => {
  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;

    if (validateEmail(enteredEmail)) {
      setErrorMsg("");
      setContinueBtn(true);
      secureLocalStorage.setItem("userEmail", enteredEmail);
      setProfile(communcateEmailPopup[2]);
      setUserEmail(enteredEmail);
    } else {
      setErrorMsg("Please enter a valid email address.");
      setContinueBtn(false);
    }
    setUserEmail(enteredEmail);
  };
  return (
    <Popup
      open={communcateEmailPopup[0]}
      position="center"
      className="pop-width"
      onClose={() => setCommunicateEmailPopup([false])}
    >
      <div className="text-center">
        <p className="text-2xl font-medium mt-10">Help Us Reach You</p>
        {/* <span className='text-lg'>"{diagnosedItem}"</span> */}
        <p className="text-sm mt-5 font-medium">
          You're using Apple’s private email system. To send you receipts,
          updates, and recovery links, we kindly ask you to provide your
          communication email address.
          <br />
        </p>
        <input
          type="email"
          name="email"
          value={userEmail || ""}
          onChange={handleEmailChange}
          placeholder="your@email.com"
          className="inputbox mt-5 sm:text-base sm:px-4 sm:py-4 py-3 px-4 text-sm rounded-xl"
        />
        <p className="text-sm text-red-500 text-center">{errorMsg}</p>

        <div className="df2 mt-5">
          {continueBtn == "Processing..." ? (
            <ContinueButton
              isdisabled={continueBtn ? "disabled" : ""}
              label={continueBtn}
            />
          ) : (
            <ContinueButton
              isdisabled={continueBtn ? "disabled" : ""}
              label={"Next"}
              className={""}
              onClick={() => {
                hanldeData(communcateEmailPopup[1], communcateEmailPopup[2]);
              }}
            />
          )}
        </div>
      </div>
    </Popup>
  );
};
